<div class="ai-chat-work-context-picker">
  <h3 class="ai-chat-work-context-picker__title">
    {{ 'chatBot.workContextPicker.title' | translateIn }}
  </h3>

  @for (group of groups; track group.group) {
    <h4 class="ai-chat-work-context-picker__group">
      @if (group.titleKey; as titleKey) {
        {{ titleKey | translateIn }}
      } @else {
        {{ group.group }}
      }
    </h4>

    <ul class="ai-chat-work-context-picker__list">
      @for (option of group.options; track workContextKey(option)) {
        <li>
          <button
            type="button"
            class="ai-chat-work-context-picker__option"
            [class.ai-chat-work-context-picker__option--selected]="isSelected(option)"
            (click)="pick(option)"
          >
            {{ workContextLabel(option) }}
          </button>
        </li>
      }
    </ul>
  }
  <div class="ai-chat-work-context-picker__actions">
    <button
      puButton
      type="button"
      uiType="secondary"
      (click)="cancel()"
    >
      {{ 'chatBot.workContextPicker.cancel' | translateIn }}
    </button>
    <button
      puButton
      type="button"
      uiType="primary"
      [disabled]="!selected()"
      (click)="confirm()"
    >
      @if (confirmSendMode) {
        {{ 'chatBot.workContextPicker.confirm' | translateIn }}
      } @else {
        {{ 'chatBot.workContextPicker.confirmNewDraft' | translateIn }}
      }
    </button>
  </div>
</div>
